import React from 'react';
import { Asset, InfoIcon } from '@clearcover/atlas';

import styles from './styles.module.css';
import { LendingLossReport } from '../Reports/LendingLoss';
import { EditProvider } from 'QuoteApp/utils/contexts/Edit';

export const NonListedDriversReport = () => {
  return (
    <EditProvider>
      {() => (
        <div className={styles.container}>
          <h3>
            Non-Listed Drivers{' '}
            <label className={styles.nonListedDriversLabel}>
              <Asset
                icon={InfoIcon}
                description="Failed"
                height={16}
                width={16}
                className={styles.icon}
              />
              These incidents occurred when a covered vehicle was entrusted to a
              driver not listed on the insurance policy.
            </label>
          </h3>
          <LendingLossReport />
        </div>
      )}
    </EditProvider>
  );
};
